export default __webpack_public_path__ + "static/media/logo_eleneo.99133793.svg";